import {
  getGridConnectionChargersPower,
  getGridConnectionMetersPower,
} from '@/services/gridConnections';
import { useQueries, useQuery } from '@tanstack/react-query';

const GRID_CONNECTION_CHARGERS_POWER_KEY = 'grid_connection_chargers_power';
const GRID_CONNECTION_METERS_POWER_KEY = 'grid_connection_meters_power';
const REFETCH_INTERVAL = 10_000;

export const useGridConnectionChargersPower = (gridConnectionId: number, enabled = true) => {
  const query = useQuery({
    queryKey: [GRID_CONNECTION_CHARGERS_POWER_KEY, gridConnectionId],
    queryFn: async () => {
      const response = await getGridConnectionChargersPower(gridConnectionId);
      const power = response.data?.task_result;
      return power ?? '';
    },
    enabled,
    refetchInterval: REFETCH_INTERVAL,
    refetchOnWindowFocus: false,
  });
  return {
    data: query.data ?? '',
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useGridConnectionsChargersPower = (gridConnectionIds: number[]) => {
  const queries = useQueries({
    queries: gridConnectionIds.map((gridConnectionId) => ({
      queryKey: [GRID_CONNECTION_CHARGERS_POWER_KEY, gridConnectionId],
      queryFn: async () => {
        const response = await getGridConnectionChargersPower(gridConnectionId);
        return response.data?.task_result ?? '';
      },
      refetchInterval: REFETCH_INTERVAL,
      refetchOnWindowFocus: false,
    })),
  });
  return gridConnectionIds.reduce<Record<number, string | undefined>>((acc, id, index) => {
    acc[id] = queries[index].data;
    return acc;
  }, {});
};

export const useGridConnectionMetersPower = (gridConnectionId: number) => {
  const query = useQuery({
    queryKey: [GRID_CONNECTION_METERS_POWER_KEY, gridConnectionId],
    queryFn: async () => {
      const response = await getGridConnectionMetersPower(gridConnectionId);
      return response.data?.power ?? '';
    },
    refetchInterval: REFETCH_INTERVAL,
    refetchOnWindowFocus: false,
  });
  return {
    data: query.data ?? '',
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useGridConnectionsMetersPower = (gridConnectionIds: number[]) => {
  const queries = useQueries({
    queries: gridConnectionIds.map((gridConnectionId) => ({
      queryKey: [GRID_CONNECTION_METERS_POWER_KEY, gridConnectionId],
      queryFn: async () => {
        const response = await getGridConnectionMetersPower(gridConnectionId);
        return response.data?.power ?? '';
      },
      refetchInterval: REFETCH_INTERVAL,
      refetchOnWindowFocus: false,
    })),
  });
  return gridConnectionIds.reduce<Record<number, string>>((acc, id, index) => {
    acc[id] = queries[index].data ?? '';
    return acc;
  }, {});
};
